
import AppCarEdit from "@/components/cars/CarsEdit.vue";
import { Car } from "@/models/base";
import { ToolbarService } from "@/services/toolbar-service";
import Vue from "vue";
import { checkHasModule } from "../../router";
import { MODULE } from "../../config/modules";
import { CarService } from "@/services/car-service";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
	data() {
		return {
			id: 0,
			car: new Car()
		};
	},
	computed: {
		title():TranslateResult{
			return ToolbarService.title;
		}
	},
	methods: {
		async onCancel() {
			await this.$router.push("/cars");
		},
		async uploadAwsDocuments(){
			this.car = await CarService.uploadDocuments(this.car);
		},
		onSave(){
			this.$emit("car-saved");
		}
	},
	async mounted() {
		this.id = parseInt(this.$route.params.id);

		if (this.id) {
			ToolbarService.title = this.$ct("edit-car");
			this.car = await CarService.get(this.id);
		} else {
			ToolbarService.title = this.$ct("new-car");
		}
	},
	created(){
		if (!checkHasModule(MODULE.WAGENPARKBEHEER_PLUS_AUTOKOSTEN, this.$router)){
			throw new Error("MISSING MODULE");
		}
	},
	components: {
		AppCarEdit
	},
	i18nEx: {
		componentPrefix: "components.car"
	}
});
